<script setup>
import { useModalogStore } from "@/stores/modalog";
import BrandConfirmModalog from "@/Components/Modalogs/BrandConfirmModalog.vue";

const modalogStore = useModalogStore();

const props = defineProps({
    retailerName: {
        type: String,
        default: null,
    },
    retailerUrl: {
        type: String,
        required: true,
    },
    item: {
        type: Object,
        default: null,
    },
    showConfirmAfter: {
        type: Boolean,
        default: false,
    },
});

function proceed() {
    window.open(props.retailerUrl, "_blank", "noopener");
    modalogStore.closeModalog();

    if (props.showConfirmAfter && props.item) {
        modalogStore.showModalog({
            type: "ModalogConfirmPurchase",
            props: { item: props.item },
            isConfirmDisabled: false,
        });
    }
}
</script>

<template>
    <BrandConfirmModalog
        :title="
            retailerName
                ? `You're heading to ${retailerName}`
                : `You're leaving Gift Hero`
        "
        :confirm-label="
            retailerName
                ? `Take me to ${retailerName} →`
                : 'Continue to store →'
        "
        @confirm="proceed"
    >
        <p>
            Complete your purchase there, then come back here to confirm your
            gift &mdash; so nobody else buys it too.
        </p>
    </BrandConfirmModalog>
</template>
